import styled from "styled-components";
import { colorMixin, focusShadowMixin } from "../../helpers";
import Badge from "../Badge";

enum FacetState {
    Hover = ":hover:not(:disabled):not(:active)",
    Focus = ":focus-visible",
    Disabled = ":disabled, [disabled]"
}

export const CountBadge = styled(Badge)``;

/**
 * @todo update hardcoded breakpoint to proper token once breakpoints are defined
 */
export const Facet = styled.button`
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    text-align: left;
    padding: 8px 12px;
    border-radius: 6px;
    gap: 8px;
    border: none;
    background: transparent;

    color: ${colorMixin("primary-700")};

    ${FacetState.Hover} {
        color: ${colorMixin("primary-900")};
        background: ${colorMixin("surface-25")};
    }

    ${FacetState.Focus} {
        color: ${colorMixin("primary-800")};
    }

    ${FacetState.Disabled} {
        color: ${colorMixin("primary-400")};
        cursor: not-allowed;
    }

    &[data-active="true"] {
        color: ${colorMixin("primary-900")};
        background: ${colorMixin("surface-50")};

        ${FacetState.Hover} {
            background: ${colorMixin("surface-25")};
        }

        ${FacetState.Focus} {
            ${focusShadowMixin("surface-100", "surface-900")}
        }

        ${FacetState.Disabled} {
            color: ${colorMixin("primary-400")};
        }

        &[data-default="true"] {
            ${CountBadge} {
                background-color: ${colorMixin("surface-100")};
            }
        }
    }

    @media only screen and (max-width: 599px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        padding: 4px 8px;
        gap: 4px;
    }
`;
